import { useToggleState } from 'shared/hooks'
import { Box, Button, Dialog, DialogContent, DialogTitle } from '@mui/material'
import { PotentiallyHtml } from '../../PotentiallyHtml'
import ReactDiffViewer from 'react-diff-viewer-continued'
import React, { useState } from 'react'
import { NodeContentUpdate } from './types'
import { getUpdateDiffs } from './utility'

export function ReplacementPreviewColumn({
  update,
}: {
  update: NodeContentUpdate
}) {
  const [showPreview, setShowPreview] = useState(false)
  const diffs = getUpdateDiffs(update)
  return (
    <Box>
      {diffs.map((diffData) => diffData.diffKey).join(', ')}
      <Button onClick={() => setShowPreview(true)}>Preview</Button>
      <ReplacementUpdatePreviewDialog
        open={showPreview}
        update={update}
        onClose={() => setShowPreview(false)}
      />
      {!!diffs.length && (
        <Box>
          <DiffSnippet {...diffs[0]} />
        </Box>
      )}
    </Box>
  )
}

function ReplacementUpdatePreviewDialog({
  open,
  update,
  onClose,
}: {
  open: boolean
  update: NodeContentUpdate
  onClose(): void
}) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="lg">
      <DialogTitle>
        <Box display="flex" flexDirection="row" justifyContent="space-between">
          <Box>Update Preview</Box>
          <Button onClick={onClose}>X</Button>
        </Box>
      </DialogTitle>
      <DialogContent>
        <ReplacementUpdatePreviews update={update} />
      </DialogContent>
    </Dialog>
  )
}

function ReplacementUpdatePreviews({ update }: { update: NodeContentUpdate }) {
  const diffs = getUpdateDiffs(update)
  return (
    <Box>
      {diffs.map((diffData) => {
        return <ReplacementUpdatePreview key={diffData.diffKey} {...diffData} />
      })}
    </Box>
  )
}

function ReplacementUpdatePreview({
  diffKey,
  oldValue,
  newValue,
}: {
  diffKey: string
  oldValue: string
  newValue: string
}) {
  const [asHtml, setAsHtml] = useToggleState(false)

  return (
    <Box
      padding="5px"
      style={{ backgroundColor: '#f5f5f5' }}
      borderRadius="5px"
    >
      <Box>
        <strong>{diffKey}</strong>
        <Button onClick={() => setAsHtml()}>HTML</Button>
      </Box>
      {asHtml && (
        <Box>
          <Box
            padding="10px"
            margin="10px"
            style={{ backgroundColor: 'white' }}
            borderRadius="5px"
          >
            <PotentiallyHtml s={oldValue} />
          </Box>
          <Box
            padding="10px"
            margin="10px"
            style={{ backgroundColor: 'white' }}
            borderRadius="5px"
          >
            <PotentiallyHtml s={newValue} />
          </Box>
        </Box>
      )}
      {!asHtml && <ReactDiffViewer oldValue={oldValue} newValue={newValue} />}
    </Box>
  )
}

function DiffSnippet({
  oldValue,
  newValue,
}: {
  oldValue: string
  newValue: string
}) {
  let diffIndex = 0
  while (oldValue[diffIndex] === newValue[diffIndex]) diffIndex++
  return <>{oldValue.slice(diffIndex - 10, diffIndex + 8)}</>
}
